// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as ReactUseScrollPosition from "react-use-scroll-position";

function boundFloat(upper, lower, arg) {
  return Math.max(lower, Math.min(upper, arg));
}

function useBackgroundScrollFade(fadeStyleFn, fadeDistancePx, fadeDirection) {
  var y = ReactUseScrollPosition.useScrollYPosition();
  var pos = y;
  var calc = pos / fadeDistancePx;
  var directedCalc = fadeDirection ? 1 - calc : calc;
  return Curry._1(fadeStyleFn, boundFloat(1, 0, directedCalc));
}

export {
  boundFloat ,
  useBackgroundScrollFade ,
}
/* react-use-scroll-position Not a pure module */
